import Footer from "../../components/Footer";
import LanImg_2 from "../../assets/img/ourStory.png";
import LanIcon_3 from "../../assets/img/Black.png";
import "../style.css";
import LanImg_1 from "../../assets/img/duo.png";
import LearnMoreSection from "./LanguageLearnMore";
export default function Doulingo() {
  const learnMoreData = {
    pageName: "Doulingo",
    heroSection: {
      header1: "Duolingo for",
      header2: "university entry",
      desc: "Duolingo is an affordable and convenient English language proficiency test for international students planning to study abroad.",
      rightImg: LanImg_1,
    },
    aboutTestSection: {
      img: LanImg_2,
      header: "What is the Duolingo English Test?",
      desc1:
        "The Duolingo English Test is an online language proficiency exam that assesses candidates’ skills in reading, writing, listening, and speaking. The test includes a 45-minute adaptive test that adjusts its difficulty based on the answers provided, and a 15-minute video interview and writing section. You can complete the test in a single sitting at home using a computer and a webcam.",
      desc2:
        "Over 5,500 institutions worldwide accept Duolingo English test results. As a fast, accessible, and cost-effective English language proficiency test, it’s an attractive option for international students looking to meet the English language entry requirements for international university admissions.",
    },
    blueCardSection: {},
    differenceSection: {
      header: "What makes the Duolingo English Test different?",
      desc: "The Duolingo English Test is a fully online English language proficiency test available on demand via your computer.",
      cards: [
        {
          img: LanIcon_3,
          header: "Fully online test",
          desc: "You can take the test anytime, anywhere, without the need to set up an appointment or visit a test centre",
        },
        {
          img: LanIcon_3,
          header: "Adaptive testing",
          desc: "The test adjusts its difficulty in real time based on your answers so you can get an accurate assessment of your skills",
        },
        {
          img: LanIcon_3,
          header: "Fast results",
          desc: "You will receive your official score within two days or within 12 hours if you choose the Faster Results option",
        },
        {
          img: LanIcon_3,
          header: "Affordable",
          desc: "The Duolingo English Test costs USD 60, making it an accessible English language proficiency test for more students worldwide",
        },
      ],
    },
    testFormatSection: {
      header: "What is a good Duolingo score?",
      desc: "Different universities have varying score requirements for the Duolingo English Test. Here’s a general comparison of Duolingo scores with IELTS and TOEFL iBT scores:",
      tableData: {
        rowHeader: ["Duolingo score", "IELTS score", "TOEFL iBT score"],
        rowData: [
          {
            column1: "155–160",
            column2: "9",
            column3: "119-120",
          },
          {
            column1: "145–150",
            column2: "8.5",
            column3: "113-118",
          },
          {
            column1: "135–140",
            column2: "8",
            column3: "104-112",
          },
          {
            column1: "125–130",
            column2: "7.5",
            column3: "93-103",
          },
          {
            column1: "115–120",
            column2: "7",
            column3: "82-92",
          },
          {
            column1: "105-110",
            column2: "6.5",
            column3: "70-81",
          },
          {
            column1: "95–100",
            column2: "6",
            column3: "59-69",
          },
          {
            column1: "85-90",
            column2: "5.5",
            column3: "47-58",
          },
          {
            column1: "75-80",
            column2: "5",
            column3: "35-46",
          },
          {
            column1: "65-70",
            column2: "4.5",
            column3: "24-34",
          },
          {
            column1: "55-60",
            column2: "4",
            column3: "17-23",
          },
          {
            column1: "45-50",
            column2: "3.5",
            column3: "0-17",
          },
          {
            column1: "30-40",
            column2: "3",
            column3: "0-17",
          },
          {
            column1: "15",
            column2: "2",
            column3: "0-17",
          },
          {
            column1: "10",
            column2: "2",
            column3: "0-17",
          },
        ],
      },
    },
  };

  return (
    <div className="language-cert">
      <LearnMoreSection learnMoreData={learnMoreData} />

      <div className="language-footer">
        <Footer />
      </div>
    </div>
  );
}
